/**
 * Generic stepped-playback timer. Domain-agnostic: it knows nothing about
 * Cytoscape, transactions, or ingestion stages — it just advances an integer
 * step on an interval while `playing`, and stops at `totalSteps`.
 *
 * Used by the fusion demo (steps = ingestion stages). The crypto Workbench
 * transaction playback can adopt the same hook (steps = transaction index).
 */
import { useEffect } from 'react';

export function usePlaybackTimer(
  playing: boolean,
  currentStep: number,
  totalSteps: number,
  onStep: (next: number) => void,
  onEnd?: () => void,
  intervalMs = 1300,
) {
  useEffect(() => {
    if (!playing) return;
    if (currentStep >= totalSteps) { onEnd?.(); return; }
    const t = setTimeout(() => onStep(currentStep + 1), intervalMs);
    return () => clearTimeout(t);
  }, [playing, currentStep, totalSteps, onStep, onEnd, intervalMs]);
}
